import {defineComponent, onMounted, ref, watch} from 'vue';
import {UserRole} from '../../../target/api/de/moovit/titletoolserver/model';

export default defineComponent({
  props: ['modelValue', 'disabled', 'placeholder', 'showClear'],
  components: {},
  setup: function (props, context) {
    let innerModelValue: any = ref(undefined);
    let userRoles = ref([]);

    watch(props, () => {
      innerModelValue.value = props.modelValue;
    });

    watch(innerModelValue, () => {
      context.emit('update:modelValue', innerModelValue.value);
    });

    onMounted(async () => {
      for (let userRole in UserRole) {
        let userRolesList: any = userRoles.value;
        if (userRolesList) userRolesList.push(userRole);
      }
    });

    return {innerModelValue, userRoles};
  },
});
